import {
  __name
} from "../../chunk-7QVYU63E.js";
var TeamPlanUsageCapType = /* @__PURE__ */ function(TeamPlanUsageCapType2) {
  TeamPlanUsageCapType2[TeamPlanUsageCapType2["AutoScale"] = 0] = "AutoScale";
  TeamPlanUsageCapType2[TeamPlanUsageCapType2["Capped"] = 1] = "Capped";
  return TeamPlanUsageCapType2;
}({});
var TeamPlanTier = /* @__PURE__ */ function(TeamPlanTier2) {
  TeamPlanTier2[TeamPlanTier2["FREE"] = 0] = "FREE";
  TeamPlanTier2[TeamPlanTier2["GROWTH"] = 1] = "GROWTH";
  TeamPlanTier2[TeamPlanTier2["ENTERPRISE"] = 2] = "ENTERPRISE";
  TeamPlanTier2[TeamPlanTier2["OTHER"] = 3] = "OTHER";
  TeamPlanTier2[TeamPlanTier2["SCALE"] = 4] = "SCALE";
  TeamPlanTier2[TeamPlanTier2["PAYG"] = 5] = "PAYG";
  return TeamPlanTier2;
}({});
var TeamPlanTerm = /* @__PURE__ */ function(TeamPlanTerm2) {
  TeamPlanTerm2[TeamPlanTerm2["MONTHLY"] = 0] = "MONTHLY";
  TeamPlanTerm2[TeamPlanTerm2["ANNUAL"] = 1] = "ANNUAL";
  return TeamPlanTerm2;
}({});
const FREE_TIERS = [
  0
];
const PAID_SELF_SERVICE_TIERS = [
  5
];
const SELF_SERVICE_TIERS = [
  ...FREE_TIERS,
  ...PAID_SELF_SERVICE_TIERS
];
const ENTERPRISE_TIERS = [
  2,
  3
];
const ALL_TIERS = [
  ...SELF_SERVICE_TIERS,
  ...ENTERPRISE_TIERS
];
const PLAN_TIER_FCUPS_LIMIT = {
  [0]: 500,
  [1]: 6e3,
  [4]: 6e3,
  [2]: 2e4,
  [3]: 2e4,
  [5]: 1e4
};
const PLAN_TIER_APP_LIMIT = {
  [0]: 5,
  [1]: 15,
  [4]: 30,
  [2]: 100,
  [3]: 100,
  [5]: 30
};
const PLAN_TIER_LABELS = {
  [0]: "Free",
  [1]: "Growth",
  [4]: "Scale",
  [2]: "Enterprise",
  [3]: "Enterprise Trial",
  [5]: "Pay As You Go"
};
const LOWER_TEAM_PLAN_TIERS = {
  [0]: [],
  [1]: [
    0
  ],
  [5]: [
    0,
    1,
    4
  ],
  [4]: [
    0,
    1
  ],
  [2]: [
    0,
    1,
    4,
    5
  ],
  [3]: [
    0,
    1,
    4
  ]
};
function isHigherTeamPlanTier(currentTier, comparisonTier) {
  return currentTier !== comparisonTier && LOWER_TEAM_PLAN_TIERS[currentTier].includes(comparisonTier);
}
__name(isHigherTeamPlanTier, "isHigherTeamPlanTier");
function isTeamPlanUpgrade(oldTier, newTier) {
  return isHigherTeamPlanTier(newTier, oldTier);
}
__name(isTeamPlanUpgrade, "isTeamPlanUpgrade");
const STRIPE_AUTHORIZATION_AMOUNT = 500;
export {
  ALL_TIERS,
  ENTERPRISE_TIERS,
  FREE_TIERS,
  PAID_SELF_SERVICE_TIERS,
  PLAN_TIER_APP_LIMIT,
  PLAN_TIER_FCUPS_LIMIT,
  PLAN_TIER_LABELS,
  SELF_SERVICE_TIERS,
  STRIPE_AUTHORIZATION_AMOUNT,
  TeamPlanTerm,
  TeamPlanTier,
  TeamPlanUsageCapType,
  isHigherTeamPlanTier,
  isTeamPlanUpgrade
};
//# sourceMappingURL=teamPlan.js.map